import { css, styled } from 'styled-components';

const TitleSection = styled.div.attrs({
    // @ts-expect-error TS2353: Object literal may only specify known properties, and ''data-qa-id'' does not exist in type 'Attrs<D
    'data-qa-id': 'page-title-section'
})`
    ${({ theme }: any) => css`
        padding: ${theme.space.lg} 0;
        text-align: center;

        ${theme.breakpoints.mq.tabletMin} {
            padding-top: ${theme.space.sm};
            padding-bottom: ${theme.space.md};
        }
        ${theme.components.TitleSection}
    `}
`;

TitleSection.displayName = 'TitleSection';

export default TitleSection;
